import React from "react";

import { Button } from "src/primitives/Button";
import { cn } from "src/shadcn/lib/utils";

import { TimezoneSelect } from "./TimezoneSelect";

interface DatePickerFooterProps {
  showTime?: boolean;
  needConfirm?: boolean;
  timezone?: string;
  onTimezoneChange?: (tz: string | undefined) => void;
  onNow: () => void;
  onOk: () => void;
  okLabel?: string;
  className?: string;
}

const DatePickerFooter: React.FC<DatePickerFooterProps> = ({
  showTime,
  needConfirm,
  timezone,
  onTimezoneChange,
  onNow,
  onOk,
  okLabel = "OK",
  className,
}) => {
  const showOkButton = showTime || needConfirm;

  return (
    <div
      className={cn(
        "flex items-center border-t border-border px-3 py-2",
        className
      )}
    >
      <Button variant="ghost" size="sm" onClick={onNow} className="text-xs">
        Now
      </Button>
      <div className="flex-1" />
      {onTimezoneChange && (
        <TimezoneSelect
          value={timezone}
          onChange={onTimezoneChange}
          className="me-2"
        />
      )}
      {showOkButton && (
        <Button size="sm" onClick={onOk} className="text-xs">
          {okLabel}
        </Button>
      )}
    </div>
  );
};

DatePickerFooter.displayName = "DatePickerFooter";

export { DatePickerFooter };
